import useLocale from "@/vue/composables/useLocale";
import { IStoreState } from "../state/state";

interface IFeeConfig {
	[locale: string]: {
		name: string,
		wiypName: string,
		value: number
	}[]
}

export default {
	fees: (state: IStoreState) => {
		const lang = useLocale() as string;

		const feeConfig: IFeeConfig = {
			"fr_FR": [
				{
					name: "fileFees",
					wiypName: "fileFees_WIYP",
					value: 24,
				},
			],
			"nl_NL": [
				{
					name: "fileFees",
					wiypName: "fileFees_WIYP",
					value: 24,
				},
				{
					name: "NL_Calamiteitenfonds",
					wiypName: "NL_Calamiteitenfonds_WIYP",
					value:
						state.participants.length < 10
							? 2.5
							: state.participants.length < 19
							? 5
							: 7.5,
				},
				{
					name: "NL_SGRcontribution",
					wiypName: "NL_SGRcontribution_WIYP",
					value: 5 * state.participants.filter((age) => age > 1).length,
				},
			],
			"en_US": [
				{
					name: "fileFees",
					wiypName: "fileFees_WIYP",
					value: 49,
				},
			],
		};

		if (state.wiypFees.length > 0 && typeof state.wiypFees[0].price === 'number') {
			const wiypFee = state.wiypFees[0].price;
			if(!feeConfig[lang][0]?.value) throw new Error("feeConfig is missing data")
			feeConfig[lang][0].value = wiypFee;
		}

		return feeConfig[lang];
	},
};